import * as React from "react";
import type { IMegaMenuSection } from "./definitions";
import { DynLabel, AppLabel } from "@@services/i18nservice";
import type { IMegaMenuPanelProps } from "./megamenupanel";
import { MegaMenuPanelBloc } from "./megamenupanel.bloc";

export interface IMegaMenuPanelSectionProps extends IMegaMenuPanelProps {    
    section: IMegaMenuSection;
}

export interface IMegaMenuPanelSectionState {

}

export class MegaMenuPanelSection extends React.Component<IMegaMenuPanelSectionProps, IMegaMenuPanelSectionState> {
    render() {
        let content = null;
        if (this.props.section.component) {
            content = React.createElement(this.props.section.component, this.props);
        } else {
            content = <>
                {this.props.section.blocs.map((s, idx) => {
                    return <MegaMenuPanelBloc key={s.key || "bloc" + idx} {...this.props} bloc={s} />;
                })}
            </>;
        }
        return <div className="megamenu-panel-section">
            {(this.props.section.label || this.props.section.title) ? <h3 className="section-title">
                {/* {this.props.section.icon ? <div className="icon"><i className={this.props.section.icon} /></div> : null} */}
                {this.props.section.label ? <DynLabel className="section-label" i18n={this.props.section.label} /> : null }
                {this.props.section.title ? <AppLabel className="section-label" i18n={this.props.section.title} /> : null }
            </h3> : null}
            <div className="megamenu-panel-section-items">
                {content}
            </div>
        </div>;
    }
}